import React, { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';
import like from "../../Assets/Image/admin/like.png";
import comment from "../../Assets/Image/admin/comment.png";
import deletes from "../../Assets/Image/admin/delete.png";
import Dialog from '../../Base-Component/Dialog/Dialog';
import Hls from "hls.js";
import { Bars, Circles } from 'react-loader-spinner';
import { deletepost, getAllpost } from '../../Services/ApiServices';
import toast from 'react-hot-toast';
import { IMG_URL } from '../../Services/Api';
import placeholderImg from "../../Assets/Image/admin/placeholder.jpg";
import moment from 'moment';
import nodata from "../../Assets/Image/admin/nodata.png";
import { useFormik } from 'formik';
import Menu from '../../Base-Component/Menu/Menu';
import view from "../../Assets/Image/admin/view.png";
import { BsThreeDotsVertical } from "react-icons/bs";
import * as Yup from "yup";
import { useDebounce } from 'use-debounce';


const Posts = () => {
    const [isOpenLike, setIsOpenLike] = useState(false);
    const [isOpenComment, setIsOpenComment] = useState(false);
    const [isDeletePost, setIsDeletePost] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchData, setSearchData] = useState("");
    const [pageNo, setPageNo] = useState(1);
    const [totalPage, setTotalPage] = useState("1");
    const [postAllData, setPostAllData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [postIdToDelete, setPostIdToDelete] = useState({});
    const [postData, setPostData] = useState([]);
    const [postLikes, setPostLikes] = useState([]);
    const [postComments, setPostComments] = useState([]);
    const [postDetailsModal, setPostDetailsModal] = useState(false);
    const [search] = useDebounce(searchData, 1000);
    

    const handleSearchChange = (e) => {
        setSearchData(e.target.value);
        setPageNo(1);
    };

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPage) {
            setPageNo(page);
        }
    };

    const renderPaginationButtonss = () => {
        const maxPagesToShow = 3;
        const buttons = [];
        const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
        const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    className={
                        i === pageNo
                            ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
                            : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
                    }
                >
                    {i}
                </button>
            );
        }
        return buttons;
    };

    const getAllPostDetails = () => {
        setLoader(true);

        let obj = {
            page: pageNo,
        }

        if (search) {
            obj.search = search;
        }

        getAllpost(obj)
            .then((res) => {
                const data = res?.data?.data;
                setPostAllData(data);
                setTotalPage(res?.data?.pagination?.totalPages);
                setLoader(false);
            })
            .catch((err) => {
                if (err.response.status == 401) {
                    localStorage.removeItem("token");
                } else {
                    toast.error(err?.response?.data?.message);
                }
                setLoader(false);
            });
    };

    useEffect(() => {
        getAllPostDetails();
    }, [pageNo, search]);

    const validationSchema = Yup.object().shape({
        reason: Yup.string()
            .trim()
            .required("Reason is required")
    });

    const formik = useFormik({
        initialValues: {
            reason: "",
        },
        validationSchema,
        onSubmit: (values, { resetForm }) => {
            setIsLoading(false);

            let obj = {
                post_id: postIdToDelete,
                reason: values?.reason,
            };

            deletepost(obj)
                .then((res) => {
                    if (res?.status === 200) {
                        toast.success(res?.data?.message);
                        getAllPostDetails();
                        resetForm();
                    }
                    setIsDeletePost(false);
                    setIsLoading(false);
                }).catch((err) => {
                    toast.error(err?.response?.data?.message);
                    setIsLoading(false);
                });
        }
    });


    const HLSVideo = ({ src }) => {
        const videoRef = useRef(null);

        useEffect(() => {
            const video = videoRef.current;
            if (video && Hls.isSupported()) {
                const hls = new Hls();
                hls.loadSource(src);
                hls.attachMedia(video);
            } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
                video.src = src;
            }
        }, [src]);

        return (
            <video ref={videoRef} className="w-full md:h-[300px] h-[250px] rounded-xl object-cover" controls />
        );
    };

    return (
        <>
            <div className='md:m-4 m-1 fontNew'>
                <div className="duration-300 cursor-pointer">
                    <div className="flex justify-end mb-4 items-start">
                        <div className="flex xl:w-70 sm:w-52 w-full h-10 px-4 sm:mb-0 mb-3 rounded-[8px] bg-white items-center">
                            <input
                                type="text"
                                required
                                className="bg-transparent sm:w-70 w-full border-none outline-none h-10 text-sm fontNew"
                                placeholder="Search..."
                                name="search_text"
                                value={searchData}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                </div>
                {loader ? (
                    <div className="flex justify-center items-center col-span-12 h-[70vh]">
                        <Bars
                            height="35"
                            width="35"
                            color="#FF4433"
                            ariaLabel="bars-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                        />
                    </div>
                ) : (
                    <>
                        {postAllData.length === 0 ? (
                            <div className="col-span-12 h-[50vh] justify-center flex items-center">
                                <img src={nodata} className="w-28" alt="No data" />
                            </div>
                        ) : (
                            <div className="grid grid-cols-12 gap-4  mt-4">
                                {postAllData && postAllData?.map((item, index) => (
                                    <div key={index} className="2xl:col-span-3 md:col-span-6 col-span-12 bg-white rounded-xl p-4">
                                        <div className="flex items-center mb-5">
                                            <img
                                                src={
                                                    item?.post_user?.profile_image ? IMG_URL + item?.post_user?.profile_image : ""
                                                }
                                                className="w-10 h-10 rounded-full object-cover "
                                                alt=""
                                            />
                                            <div>
                                                <p className="text-base ms-3">
                                                    {item?.post_user?.firstname || "-"}{" "}
                                                    {item?.post_user?.lastname || ""}

                                                </p>
                                                <p className="text-xs text-[#828282] ms-3">{moment(item?.createdAt).fromNow()}</p>
                                            </div>
                                        </div>
                                        {item?.post_images?.map((imageUrl, imageIndex) => {
                                            const postUrl = imageUrl?.post_url;

                                            if (imageUrl.type == 1) {
                                                if (postUrl.endsWith('.mp4') || postUrl.endsWith('.avi') || postUrl.endsWith('.mov') || postUrl.endsWith('.webm')) {
                                                    return (
                                                        <video key={imageIndex} className="w-full h-[300px] rounded-xl object-cover" controls>
                                                            <source src={IMG_URL + postUrl} type={`video/${postUrl.split('.').pop()}`} />
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    );
                                                } else if (postUrl.endsWith('.m3u8')) {
                                                    return <HLSVideo key={imageIndex} src={IMG_URL + postUrl} />;
                                                }
                                            }

                                            return (
                                                <img
                                                    key={imageIndex}
                                                    src={postUrl ? IMG_URL + postUrl : placeholderImg}
                                                    alt="Post"
                                                    className="w-full md:h-[300px] h-[250px] rounded-xl object-cover"
                                                />
                                            );
                                        })}

                                        <div className="mt-3.5 flex items-center justify-between">
                                            <div className="flex w-full justify-between items-center">
                                                <div className="flex items-center gap-2.5">
                                                    <div className="flex items-center gap-1.5 cursor-pointer" onClick={() => {
                                                        setIsOpenLike(true)
                                                        setPostLikes(item.likes)
                                                    }}>
                                                        <img src={like} alt="..." className="w-3.5" />
                                                        <span className="text-sm">{item?.likes?.length || 0}</span>
                                                    </div>
                                                    <div className="flex items-center gap-1.5 cursor-pointer" onClick={() => {
                                                        setIsOpenComment(true)
                                                        setPostComments(item.comments)
                                                    }}>
                                                        <img src={comment} alt="..." className="w-5" />
                                                        <span className="text-sm">{item?.comments?.length || 0}</span>
                                                    </div>
                                                </div>
                                                <Menu className={`mt-2`}>
                                                    <Menu.Button className="block">
                                                        <BsThreeDotsVertical className="text-xl" />
                                                    </Menu.Button>
                                                    <Menu.Items className="w-56 bg-white mt-5 fontNew">
                                                        <Menu.Item
                                                            className="hover:bg-gray-50 border-b border-gray-100 text-[#303438] flex justify-between items-center py-2"
                                                        >
                                                            <div className="flex w-full items-center"
                                                                onClick={() => {
                                                                    setPostDetailsModal(true)
                                                                    setPostData(item)
                                                                }}>
                                                                <img
                                                                    src={view}
                                                                    className="lg:w-9 w-8"
                                                                    alt="view"
                                                                />
                                                                <p className="m-0 ms-3">View Details</p>
                                                            </div>
                                                        </Menu.Item>
                                                        <Menu.Item
                                                            className="hover:bg-gray-50 text-[#303438] flex justify-between items-center py-2"
                                                        >
                                                            <div className="flex w-full items-center"
                                                                onClick={() => {
                                                                    setPostIdToDelete(item?.id)
                                                                    setIsDeletePost(true);
                                                                }}>
                                                                <img
                                                                    src={deletes}
                                                                    className="lg:w-9 w-8"
                                                                    alt="Delete"
                                                                />
                                                                <p className="m-0 ms-3">Delete</p>
                                                            </div>
                                                        </Menu.Item>
                                                    </Menu.Items>
                                                </Menu>
                                            </div>
                                        </div>
                                        <div className="mt-3.5">
                                            <p className="md:text-base text-sm font-medium">{item?.post_type || ''}</p>
                                            <p className="text-sm text-gray-400 font-normal line-clamp-3">{item?.caption_message || ""}</p>
                                        </div>
                                    </div>
                                ))}
                                {postAllData.length > 0 ? <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                                    <div className="flex items-center cursor-pointer">
                                        <p
                                            onClick={() => handlePageChange(pageNo - 1)}
                                            disabled={pageNo === 1}
                                        >
                                            Previous
                                        </p>
                                        <div className="flex items-center mx-6">
                                            {renderPaginationButtonss()}
                                        </div>
                                        <p
                                            onClick={() => handlePageChange(pageNo + 1)}
                                            disabled={pageNo === totalPage}
                                        >
                                            Next
                                        </p>
                                    </div>
                                </div>
                                    : ""
                                }
                            </div>

                        )}
                    </>
                )}
            </div >

            <Dialog
                open={isOpenLike}
                onClose={() => setIsOpenLike(false)}
                size="md"
            >
                <Dialog.Panel>
                    <Dialog.Description className="rounded-none border-2 border-white">
                        <div className="my-4 sm:px-8 px-4 fontNew max-h-[370px] overflow-y-auto">
                            <div className="flex items-center justify-between mb-4">
                                <h3 className="text-xl font-semibold text-center flex-grow">Users like</h3>
                                <X className="w-5 h-5 cursor-pointer" onClick={() => setIsOpenLike(false)} />
                            </div>
                            <div className="md:max-h-[500px] max-h-[400px]">
                                {postLikes.length > 0 ? postLikes?.map((item, index) => (
                                    <div key={index} className={`py-2.5 border-b-2 last:border-none border-[#f1f1f1]`}>
                                        <div className="flex items-center">
                                            <img
                                                src={
                                                    item?.user?.profile_image ? IMG_URL + item?.user?.profile_image : placeholderImg
                                                }
                                                className="w-10 h-10 rounded-full object-cover"
                                                alt=""
                                            />
                                            <p className="md:text-base text-sm ms-3">
                                                {item?.user?.firstname || "-"}{" "}
                                                {item?.user?.lastname || ""}
                                            </p>
                                        </div>
                                    </div>
                                )) :
                                    <p className="md:text-[15px] text-sm mt-10 font-medium w-full col-span-12 text-center text-gray-400">No likes available</p>
                                }
                            </div>
                        </div>
                    </Dialog.Description>
                </Dialog.Panel>
            </Dialog>

            <Dialog
                open={isOpenComment}
                onClose={() => setIsOpenComment(false)}
                size="md"
            >
                <Dialog.Panel>
                    <Dialog.Description className="rounded-none border-2 border-white">
                        <div className="sm:px-8 px-4 my-4 fontNew max-h-[370px] overflow-y-auto">
                            <div className="flex items-center justify-between mb-4">
                                <h3 className="text-xl font-semibold text-center flex-grow">Users comment</h3>
                                <X className="w-5 h-5 cursor-pointer" onClick={() => setIsOpenComment(false)} />
                            </div>
                            <div className="md:max-h-[500px] max-h-[400px]">
                                {postComments.length > 0 ? postComments?.map((item, index) => (
                                    <div key={index} className={`py-2.5 border-b-2 last:border-none border-[#f1f1f1]`}>
                                        <div className="flex items-center">
                                            <img
                                                src={
                                                    item?.commented_user?.profile_image ? IMG_URL + item?.commented_user?.profile_image : placeholderImg
                                                }
                                                className="w-10 h-10 rounded-full object-cover"
                                                alt=""
                                            />
                                            <p className="md:text-base text-sm font-semibold ms-3">
                                                {item?.commented_user?.firstname || ""}{" "}
                                                {item?.commented_user?.lastname || ""}
                                            </p>
                                        </div>
                                        <div className="flex items-center ml-[50px] space-x-1">
                                            <img src={comment} alt="..." className="w-5" />
                                            <span className="text-gray-500 font-normal md:text-sm text-xs">
                                                {item.comment_message || ''}
                                            </span>
                                        </div>
                                    </div>
                                )) :
                                    <p className="md:text-[15px] text-sm mt-10 font-medium w-full col-span-12 text-center text-gray-400">No comments available</p>
                                }
                            </div>
                        </div>
                    </Dialog.Description>
                </Dialog.Panel>
            </Dialog>

            <Dialog
                open={isDeletePost}
                onClose={() => setIsDeletePost(false)}
                size="md"
            >
                <Dialog.Panel>
                    <Dialog.Description className="rounded-none border-2 border-white">
                        <div className="flex justify-center my-4 sm:px-16 px-5 fontNew">
                            <div>
                                <h4 className="text-xl font-semibold text-center text-black mt-6">
                                    Delete Post?
                                </h4>
                                <form onSubmit={formik?.handleSubmit}>
                                    <div className="my-3">
                                        <label className="text-base ">Reason :</label>
                                        <textarea
                                            type="text"
                                            name="reason"
                                            rows={4}
                                            value={formik?.values?.reason}
                                            className={`bg-transparent px-4 pt-2 rounded-xl border-2 w-full outline-secondary text-base mt-2 ${formik.errors.reason && formik.touched.reason
                                                ? "border-red-500"
                                                : "border-slate-300"
                                                }`}
                                            placeholder="Enter the reason"
                                            onBlur={formik.handleBlur}
                                            onChange={formik?.handleChange}
                                        />
                                        {formik.errors.reason && formik.touched.reason && (
                                            <p className="text-red-500 text-sm mt-1">
                                                {formik.errors.reason}
                                            </p>
                                        )}
                                    </div>
                                    <div className="flex items-center justify-center mt-10 mb-10">
                                        <button
                                            className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                                            onClick={() => setIsDeletePost(false)}
                                        >
                                            Close
                                        </button>
                                        <button
                                            type="submit"
                                            disabled={isLoading}
                                            className="bg-[#ea5f5f] h-[50px] disabled:bg-red-400 sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                                        >
                                            {isLoading ? (
                                                <div className="flex justify-center">
                                                    <Circles
                                                        width={25}
                                                        height={25}
                                                        color="#fff"
                                                        ariaLabel="circles-loading"
                                                        wrapperStyle={{}}
                                                        visible={true}
                                                        wrapperClass=""
                                                    />
                                                </div>
                                            ) : (
                                                "Delete"
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Dialog.Description>
                </Dialog.Panel>
            </Dialog>

            <Dialog
                open={postDetailsModal}
                onClose={() => setPostDetailsModal(false)}
                size="md"
            >
                <Dialog.Panel>
                    <Dialog.Description className="rounded-none border-2 border-white">
                        <div className="sm:px-8 px-4 my-4 fontNew">
                            <div className="flex items-center justify-between mb-4">
                                <h3 className="text-xl font-semibold text-center flex-grow">Post Details</h3>
                                <X className="w-5 h-5 cursor-pointer" onClick={() => setPostDetailsModal(false)} />
                            </div>
                            <div className="md:max-h-[550px] max-h-[400px] overflow-y-auto">
                                {postData?.post_images?.map((imageUrl, imageIndex) => {
                                    const postUrl = imageUrl?.post_url;

                                    if (imageUrl.type == 1) {
                                        if (postUrl.endsWith('.mp4') || postUrl.endsWith('.avi') || postUrl.endsWith('.mov') || postUrl.endsWith('.webm')) {
                                            return (
                                                <video key={imageIndex} className="w-full h-[300px] rounded-xl object-cover" controls>
                                                    <source src={IMG_URL + postUrl} type={`video/${postUrl.split('.').pop()}`} />
                                                    Your browser does not support the video tag.
                                                </video>
                                            );
                                        } else if (postUrl.endsWith('.m3u8')) {
                                            return <HLSVideo key={imageIndex} src={IMG_URL + postUrl} />;
                                        }
                                    }

                                    return (
                                        <img
                                            key={imageIndex}
                                            src={postUrl ? IMG_URL + postUrl : placeholderImg}
                                            alt="Post"
                                            className="w-full md:h-[300px] h-[250px] rounded-xl object-cover"
                                        />
                                    );
                                })}
                                <div className="flex items-center gap-2.5 mt-3">
                                    <div className="flex items-center gap-1.5 cursor-pointer">
                                        <img src={like} alt="..." className="w-3.5" />
                                        <span className="text-sm">{postData?.likes?.length || 0}</span>
                                    </div>
                                    <div className="flex items-center gap-1.5 cursor-pointer">
                                        <img src={comment} alt="..." className="w-5" />
                                        <span className="text-sm">{postData?.comments?.length || 0}</span>
                                    </div>
                                </div>
                                {postData?.post_type && <div className="mt-3">
                                    <p className="md:text-sm font-medium text-sm">
                                        Post type : {' '}
                                        <span className="text-gray-500 ">{postData?.post_type}</span>
                                    </p>
                                </div>}
                                {postData?.caption_message && <div className="mt-1">
                                    <p className="md:text-sm font-medium text-sm">
                                        Caption Message : {' '}
                                        <span className="text-gray-500 ">{postData?.caption_message}</span>
                                    </p>
                                </div>}
                            </div>
                        </div>
                    </Dialog.Description>
                </Dialog.Panel>
            </Dialog>
        </>
    );
};

export default Posts;
